import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=42127970&"
import script from "./ReviewCard.vue?vue&type=script&lang=js&"
export * from "./ReviewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default,UiReadMoreClamp: require('/app/components/UI/UiReadMoreClamp.vue').default})
